import { privateAxios } from 'services/api/privateAxios';

export const getCustomerInfo = () =>
  privateAxios({
    method: 'get',
    url: '/customer/accountinfo',
  });
